import { useEffect } from 'react';
import { createPortal } from 'react-dom';

type ErrorOverlayProps = {
  message: string;
  title?: string;
  onClose: () => void;
};

/** Dismissible error dialog styled like VerifyingOverlay (dimmed page + centered card). */
export function ErrorOverlay({
  message,
  title = 'Error',
  onClose,
}: ErrorOverlayProps) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  if (typeof document === 'undefined') return null;

  return createPortal(
    <div
      className="verifying-overlay error-overlay"
      role="alertdialog"
      aria-modal="true"
      aria-live="assertive"
      aria-labelledby="error-overlay-title"
      aria-describedby="error-overlay-message"
      onClick={onClose}
    >
      <div
        className="verifying-overlay__dialog error-overlay__dialog"
        role="document"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="error-overlay__close"
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>
        <p id="error-overlay-title" className="error-overlay__title">
          {title}
        </p>
        <p id="error-overlay-message" className="verifying-overlay__message error-overlay__message">
          {message}
        </p>
      </div>
    </div>,
    document.body,
  );
}
